export const I18N_SERP_NS = 'app_serp';
